import { BOPatientAllergies } from '../BOPatientAllergies.model';

export class BOTranspPatientAllergies {
    PatientAllergies:BOPatientAllergies[]=[];
    patientId:number;
}
